import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const ServiceJobTypeUrl = `${Base_Url}/ServiceJob`;

export const GetServiceJobList = async (params) => {
  const res = await postApiWithAuthorization(
    `${ServiceJobTypeUrl}/GetServiceJobList?ServiceKeyID=${params.serviceKeyID}`,
    params
  );
  return res;
};

export const AddUpdateServiceJob = async (params) => {
  const res = await postApiWithAuthorization(
    `${ServiceJobTypeUrl}/AddUpdateServiceJob?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetServiceJobModel = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${ServiceJobTypeUrl}/GetServiceJobModel?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ServiceJobKeyID=${KeyID}`
  );
  return res;
};

export const ChangeServiceJobStatus = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${ServiceJobTypeUrl}/ChangeServiceJobStatus?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ServiceJobKeyID=${KeyID}`
  );
  return res;
};

export const DeleteServiceJob = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${ServiceJobTypeUrl}/DeleteServiceJob?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&ServiceJobKeyID=${KeyID}`
  );
  return res;
};
